import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowTeamWinner = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 5,
	height: 9,
	viewBox: "0 0 5 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.5 1L1 4.5L4.5 8",
		stroke: "currentColor"
	})
});
export default SvgArrowTeamWinner;
